<template>
  <div id="app">
    <el-container>
      <el-header class="app-header">
<!--        <img :src="bannerImages[step - 1]" alt="Banner" class="top-banner">-->
      </el-header>

      <div class="custom-main">
        <div class="step-indicator">
          <div v-for="s in 7" :key="s" class="step-item">
            <div :class="{ 'step-circle': true, 'active': step >= s }">{{ s }}</div>
            <div class="step-label" v-if="s === 1">创作故事</div>
            <div class="step-label" v-else-if="s === 2">确认故事</div>
            <div class="step-label" v-else-if="s === 3">角色信息</div>
            <div class="step-label" v-else-if="s === 4">分镜脚本</div>
            <div class="step-label" v-else-if="s === 5">生成图像</div>
            <div class="step-label" v-else-if="s === 6">绘本内容</div>
            <div class="step-label" v-else-if="s === 7">完成</div>
          </div>
        </div>

        <div class="main-content">
          <!-- 故事创作 (Step 1) -->
          <div v-if="step === 1" class="step-container" v-loading="loading" element-loading-text="正在生成故事...">
            <h2 class="step-title">第一步：创作故事</h2>
            <el-form :model="storyForm" label-width="100px" class="story-form">
              <el-form-item label="故事主题">
                <el-input type="textarea" v-model="storyForm.outline" placeholder="请输入您的故事主题或创意..."></el-input>
              </el-form-item>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="读者年龄">
                    <el-select v-model="storyForm.reader_age" placeholder="选择读者年龄" class="full-width">
                      <el-option label="3-5岁" value="3-5"></el-option>
                      <el-option label="6-8岁" value="6-8"></el-option>
                      <el-option label="9-12岁" value="9-12"></el-option>
                      <el-option label="不限" value="any"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="读者性别">
                    <el-select v-model="storyForm.reader_gender" placeholder="选择读者性别" class="full-width">
                      <el-option label="男孩" value="boy"></el-option>
                      <el-option label="女孩" value="girl"></el-option>
                      <el-option label="不限" value="any"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="语言风格">
                    <el-select v-model="storyForm.language_style" placeholder="选择语言风格" class="full-width">
                      <el-option label="口语化" value="colloquial"></el-option>
                      <el-option label="书面化" value="formal"></el-option>
                      <el-option label="幽默" value="humorous"></el-option>
                      <el-option label="简洁" value="concise"></el-option>
                      <el-option label="诗意" value="poetic"></el-option>
                      <el-option label="悬疑" value="suspenseful"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="故事类型">
                <el-select v-model="storyForm.genre" placeholder="选择故事类型" class="full-width">
                  <el-option label="冒险" value="adventure"></el-option>
                  <el-option label="童话" value="fairytale"></el-option>
                  <el-option label="科幻" value="science_fiction"></el-option>
                  <el-option label="喜剧" value="comedy"></el-option>
                  <el-option label="教育" value="educational"></el-option>
                  <el-option label="历史" value="historical"></el-option>
                  <el-option label="奇幻" value="fantasy"></el-option>
                  <el-option label="推理" value="mystery"></el-option>
                  <el-option label="恐怖" value="horror"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="主旨思想" class="theme-checkboxes">
                <el-checkbox-group v-model="storyForm.themes" class="checkbox-wrap">
                  <el-checkbox label="友谊" value="friendship"></el-checkbox>
                  <el-checkbox label="勇气" value="courage"></el-checkbox>
                  <el-checkbox label="家庭" value="family"></el-checkbox>
                  <el-checkbox label="成长" value="growth"></el-checkbox>
                  <el-checkbox label="探索" value="exploration"></el-checkbox>
                  <el-checkbox label="爱" value="love"></el-checkbox>
                  <el-checkbox label="责任" value="responsibility"></el-checkbox>
                  <el-checkbox label="环保" value="environmentalism"></el-checkbox>
                  <el-checkbox label="正义" value="justice"></el-checkbox>
                  <el-checkbox label="合作" value="cooperation"></el-checkbox>
                </el-checkbox-group>
                <el-input v-model="storyForm.customThemes" placeholder="自定义主旨，多个用逗号隔开"></el-input>
              </el-form-item>

              <el-form-item label="其他设定" class="setting-checkboxes">
                <el-checkbox-group v-model="storyForm.settings" class="checkbox-wrap">
                  <el-checkbox label="魔法世界" value="magical_world"></el-checkbox>
                  <el-checkbox label="未来世界" value="future_world"></el-checkbox>
                  <el-checkbox label="现实世界" value="real_world"></el-checkbox>
                  <el-checkbox label="外星世界" value="alien_world"></el-checkbox>
                  <el-checkbox label="古代" value="ancient_times"></el-checkbox>
                  <el-checkbox label="水下世界" value="underwater_world"></el-checkbox>
                  <el-checkbox label="拟人动物" value="anthropomorphic_animals"></el-checkbox>
                </el-checkbox-group>
                <el-input v-model="storyForm.customSettings" placeholder="自定义设定，多个用逗号隔开"></el-input>
              </el-form-item>

              <div class="center-buttons">
                <el-button type="primary" @click="generateStory" :disabled="loading" class="action-button">
                  <el-icon><MagicStick /></el-icon> 生成故事
                </el-button>
              </div>
            </el-form>
          </div>

          <!-- 故事确认 (Step 2) -->
          <div v-if="step === 2" class="step-container" v-loading="loading2" element-loading-text="正在分析故事...">
            <h2 class="step-title">第二步：确认故事内容</h2>
            <el-form :model="visualOptionsForm" label-width="80px" class="story-confirm-form">
              <el-form-item label="故事内容">
                <el-input type="textarea" v-model="editableStory" :rows="10" class="full-width"></el-input>
              </el-form-item>

              <el-form-item label="画面风格" class="style-selection">
                <el-radio-group v-model="visualOptionsForm.style">
                  <el-radio label="卡通" value="cartoon">
                    <div class="style-radio-content">
                      <el-icon><Film /></el-icon> 卡通
                    </div>
                  </el-radio>
                  <el-radio label="水彩" value="watercolor">
                    <div class="style-radio-content">
                      <el-icon><Brush /></el-icon> 水彩
                    </div>
                  </el-radio>
                  <el-radio label="油画" value="oil_painting">
                    <div class="style-radio-content">
                      <el-icon><PictureIcon /></el-icon> 油画
                    </div>
                  </el-radio>
                  <el-radio label="素描" value="sketch">
                    <div class="style-radio-content">
                      <el-icon><Edit /></el-icon> 素描
                    </div>
                  </el-radio>
                  <el-radio label="动漫" value="anime">
                    <div class="style-radio-content">
                      <el-icon><StarIcon /></el-icon> 动漫
                    </div>
                  </el-radio>
                  <el-radio label="像素艺术" value="pixel_art">
                    <div class="style-radio-content">
                      <el-icon><Coin /></el-icon> 像素
                    </div>
                  </el-radio>
                </el-radio-group>
              </el-form-item>

              <div class="center-buttons">
                <el-button @click="backtoLast" type="default" class="action-button prev-button">
                  <el-icon><ArrowLeft /></el-icon> 返回上一步
                </el-button>
                <el-button type="primary" @click="confirmStory" :disabled="loading2" class="action-button">
                  <el-icon><Check /></el-icon> 确认故事
                </el-button>
              </div>
            </el-form>
          </div>

          <!-- 角色信息确认 (Step 3) -->
          <div v-if="step === 3" class="step-container" v-loading="loading3" element-loading-text="正在生成分镜...">
            <h2 class="step-title">第三步：确认角色信息</h2>

            <div class="character-list">
              <div v-for="(character, index) in characterInfo" :key="index" class="character-container">
                <div class="character-header">
                  <h3 class="character-title">角色 {{ index + 1 }}</h3>
                  <el-button type="danger" plain @click="removeCharacter(index)" v-if="characterInfo.length > 1" class="delete-btn">
                    <el-icon><Delete /></el-icon> 删除
                  </el-button>
                </div>

                <div class="character-content">
                  <!-- 左侧：角色信息 -->
                  <div class="character-info">
                    <el-form label-width="120px" class="character-form">
                      <el-form-item label="角色姓名">
                        <el-input v-model="character.name" placeholder="请输入角色姓名"></el-input>
                      </el-form-item>

                      <el-form-item label="基本形象特征">
                        <div class="tag-container">
                          <el-tag
                            v-for="(tag, tagIndex) in character.basic_features"
                            :key="tagIndex"
                            closable
                            class="feature-tag"
                            @close="removeTag(character.basic_features, tagIndex)">
                            {{ tag }}
                          </el-tag>
                        </div>
                        <el-input
                          v-model="newBasicTag[index]"
                          placeholder="添加新标签（回车确认）"
                          @keyup.enter="addTag(character.basic_features, index, 'basic')"
                          class="tag-input">
                        </el-input>
                      </el-form-item>

                      <el-form-item label="服装特征">
                        <div class="tag-container">
                          <el-tag
                            v-for="(tag, tagIndex) in character.clothing_features"
                            :key="tagIndex"
                            closable
                            class="feature-tag"
                            type="success"
                            @close="removeTag(character.clothing_features, tagIndex)">
                            {{ tag }}
                          </el-tag>
                        </div>
                        <el-input
                          v-model="newClothingTag[index]"
                          placeholder="添加新标签（回车确认）"
                          @keyup.enter="addTag(character.clothing_features, index, 'clothing')"
                          class="tag-input">
                        </el-input>
                      </el-form-item>

                      <div class="center-buttons">
                        <el-button
                          type="primary"
                          @click="generateCharacterImage(index)"
                          :loading="loadingImage[index]"
                          class="generate-image-btn">
                          <el-icon><PictureIcon /></el-icon> 生成参考图
                        </el-button>
                      </div>
                    </el-form>
                  </div>

                  <!-- 右侧：参考图 -->
                  <div class="character-image">
                    <div class="image-preview">
                      <el-image
                        v-if="character.reference_image"
                        style="width: 100%; height: 100%"
                        :src="character.reference_image"
                        :preview-src-list="[character.reference_image]"
                        fit="contain">
                        <template #placeholder>
                          <div class="image-loading">
                            <el-icon class="is-loading"><Loading /></el-icon>
                            <span>加载中...</span>
                          </div>
                        </template>
                      </el-image>
                      <div v-else class="no-image">
                        <el-icon><PictureIcon /></el-icon>
                        <p>暂无参考图</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="add-character-wrapper">
              <el-button
                type="success"
                @click="addCharacter"
                :disabled="characterInfo.length >= 4"
                class="add-character-btn">
                <el-icon><Plus /></el-icon> 添加角色
              </el-button>
            </div>

            <div class="center-buttons">
              <el-button @click="backtoLast" type="default" class="action-button prev-button">
                <el-icon><ArrowLeft /></el-icon> 返回上一步
              </el-button>
              <el-button type="primary" @click="confirmCharacters" :disabled="loading3" class="action-button">
                <el-icon><Check /></el-icon> 确认角色
              </el-button>
            </div>
          </div>

          <!-- 分镜脚本确认 (Step 4) -->
          <div v-if="step === 4" class="step-container" v-loading="loading4" element-loading-text="正在准备...">
            <h2 class="step-title">第四步：分镜脚本确认</h2>
            <div class="script-grid">
              <div v-for="(item, index) in script" :key="index" class="script-item">
                <div class="script-header">
                  <span class="script-number">分镜 {{ index + 1 }}</span>
                  <span class="script-scene">{{ item.scene }}</span>
                </div>
                <el-form :model="item" label-width="80px" class="script-form">
                  <el-form-item label="分镜故事">
                    <el-input type="textarea" v-model="item.story_description" :rows="4" class="script-textarea"></el-input>
                  </el-form-item>
                  <el-form-item label="画面描述">
                    <el-input type="textarea" v-model="item.image_description" :rows="4" class="script-textarea"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div class="center-buttons">
              <el-button @click="backtoLast" type="default" class="action-button prev-button">
                <el-icon><ArrowLeft /></el-icon> 返回上一步
              </el-button>
              <el-button type="primary" @click="confirmScript" class="action-button">
                <el-icon><Check /></el-icon> 确认分镜脚本
              </el-button>
            </div>
          </div>

          <!-- 图像生成 (Step 5) -->
          <div v-if="step === 5" class="step-container" v-loading="loading5" element-loading-text="正在生成图像...">
            <h2 class="step-title">第五步：生成图像</h2>
            <div class="page-container">
              <div class="page-header">
                <div class="page-navigation">
                  <el-button
                    :disabled="currentPage === 0"
                    @click="prevPage"
                    type="default"
                    class="nav-btn">
                    <el-icon><ArrowLeft /></el-icon>
                  </el-button>
                  <div class="page-indicator">{{ currentPage + 1 }} / {{ script.length }}</div>
                  <el-button
                    :disabled="currentPage === script.length - 1"
                    @click="nextPage"
                    type="default"
                    class="nav-btn">
                    <el-icon><ArrowRight /></el-icon>
                  </el-button>
                </div>
              </div>

              <div class="page-content">
                <div class="page-left">
                  <p class="scene-title">
                    <span class="scene-number">分镜 {{ currentPage + 1 }}</span>
                    <span class="scene-name">{{ script[currentPage].scene }}</span>
                  </p>
                  <el-form :model="script[currentPage]" label-width="80px" class="image-gen-form">
                    <el-form-item label="画面描述">
                      <el-input
                        type="textarea"
                        v-model="script[currentPage].image_description"
                        :rows="8"
                        class="description-textarea">
                      </el-input>
                    </el-form-item>
                    <el-form-item label="配文">
                      <el-input
                        type="textarea"
                        v-model="script[currentPage].text"
                        :rows="8"
                        class="text-textarea">
                      </el-input>
                    </el-form-item>
                  </el-form>
                  <div class="center-buttons">
                    <el-button
                      type="primary"
                      @click="generateCurrentImage"
                      :disabled="loading5"
                      class="generate-btn">
                      <el-icon><PictureIcon /></el-icon> 生成图像
                    </el-button>
                  </div>
                </div>
                <div class="page-right">
                  <div class="image-container">
                    <el-image
                      v-if="pageImages[currentPage]"
                      :src="pageImages[currentPage]"
                      alt="Generated Image"
                      class="generated-image"
                      fit="contain"
                      :preview-src-list="[pageImages[currentPage]]">
                    </el-image>
                    <div v-else class="no-image-placeholder">
                      <el-icon><PictureIcon /></el-icon>
                      <p>请点击"生成图像"按钮生成图像</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="center-buttons action-buttons">
                <el-button @click="backtoLast" type="default" class="action-button prev-button">
                  <el-icon><ArrowLeft /></el-icon> 返回上一步
                </el-button>
                <el-button
                  type="primary"
                  @click="confirmAllImages"
                  v-if="currentPage === script.length - 1"
                  class="action-button">
                  <el-icon><Check /></el-icon> 确认所有图像
                </el-button>
              </div>
            </div>
          </div>

          <!-- 绘本内容确认 (Step 6) -->
          <div v-if="step === 6" class="step-container" v-loading="loading6" element-loading-text="正在制作绘本...">
            <h2 class="step-title">第六步：绘本内容确认</h2>
            <div class="content-wrapper">
              <div class="form-section">
                <el-form :model="storyForm" label-width="60px" class="book-info-form">
                  <el-form-item label="标题">
                    <el-input ref="titleInputRef" v-model="storyForm.title" placeholder="输入绘本标题" prefix-icon="el-icon-reading">
                      <template #prefix>
                        <el-icon><Reading /></el-icon>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="作者">
                    <el-input ref="authorInputRef" v-model="author" placeholder="输入作者姓名" prefix-icon="el-icon-user">
                      <template #prefix>
                        <el-icon><User /></el-icon>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-form>
              </div>

              <div class="four-grid-container">
                <div v-for="(panel, index) in script" :key="index" class="grid-item">
                  <div class="grid-item-inner">
                    <div class="grid-image-container">
                      <el-image
                        :src="panel.image_url"
                        :alt="'分镜' + (index + 1)"
                        class="grid-image"
                        fit="contain"
                        :preview-src-list="[panel.image_url]">
                      </el-image>
                      <span class="page-number">{{ index + 1 }}</span>
                    </div>
                    <el-form :model="panel" label-width="60px" class="grid-text-form">
                      <el-form-item label="配文">
                        <el-input
                          type="textarea"
                          v-model="panel.text"
                          :rows="4"
                          class="grid-textarea">
                        </el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>

              <div class="center-buttons">
                <el-button @click="backtoLast" type="default" class="action-button prev-button">
                  <el-icon><ArrowLeft /></el-icon> 返回上一步
                </el-button>
                <el-button
                  type="primary"
                  @click="generateBook"
                  :disabled="loading6"
                  class="action-button">
                  <el-icon><Collection /></el-icon> 确认制作绘本
                </el-button>
              </div>
            </div>
          </div>

          <!-- 绘本完成 (Step 7) -->
          <div v-if="step === 7" class="step-container final-step">
            <h2 class="step-title success-title">
              <el-icon :size="28" color="var(--secondary-color)"><SuccessFilled /></el-icon> 绘本已生成！
            </h2>
            <div class="completion-container">
              <div v-if="qrcodeBase64" class="qrcode-container">
                <img
                  :src="'data:image/png;base64,' + qrcodeBase64"
                  alt="绘本二维码"
                  class="qrcode-image">
                <p class="qrcode-hint">扫描二维码查看绘本</p>
              </div>
              <div class="action-buttons">
                <a :href="firstPageUrl" target="_blank" class="book-link">
                  <el-button type="primary" class="start-reading-button">
                    <el-icon><Reading /></el-icon> 开始阅读
                  </el-button>
                </a>
                <el-button
                  type="success"
                  @click="exportBook"
                  :loading="exporting"
                  class="export-button">
                  <el-icon><Download /></el-icon> 导出长图
                </el-button>
              </div>
              <div class="restart-container">
                <el-button
                  type="warning"
                  @click="resetApp"
                  class="new-book-button">
                  <el-icon><Refresh /></el-icon> 创作新绘本
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import axios from 'axios';
// Import Element Plus components - In <script setup>, they are automatically available to the template
// You might have these globally registered, but importing explicitly is fine too.
// Note: ElIcon is needed to wrap the icon components
import { ElMessage } from 'element-plus';

// Import Element Plus Icons
import {
  ArrowLeft,
  ArrowRight,
  Check,
  MagicStick,
  Film,
  Brush,
  Picture as PictureIcon,
  Edit,
  Star as StarIcon,
  Coin,
  Delete,
  Plus,
  Collection,
  Reading,
  User,
  SuccessFilled,
  Download,
  Refresh,
  Loading // Icon for loading states
} from '@element-plus/icons-vue';

// --- State (Replaces data()) ---
const step = ref(1);
const loading = ref(false);
const loading2 = ref(false);
const loading3 = ref(false);
const loading4 = ref(false);
const loading5 = ref(false);
const loading6 = ref(false);

const storyForm = reactive({
  title: '',
  outline: '',
  character_names: '', // This wasn't used in the original template for step 1, but keeping it
  genre: '',
  themes: [],
  customThemes: '',
  settings: [],
  customSettings: '',
  reader_age: '',
  reader_gender: '',
  language_style: '',
});

const visualOptionsForm = reactive({ style: 'cartoon' });

const story = ref('');
const editableStory = ref('');

// Use reactive for arrays/objects where items/properties are added/removed/modified
const characterInfo = reactive([]);
const newBasicTag = reactive([]); // Input models for new tags per character
const newClothingTag = reactive([]);
const loadingImage = reactive([]); // Loading state per character image

const script = reactive([]); // Array of script panels

// Use ref for primitives or when the whole value might be replaced
const currentPage = ref(0);
const pageImages = ref([]); // Array of image URLs for each page/panel
const imageUrl = ref(''); // Seems unused, but kept from original
const firstPageUrl = ref('');
const qrcodeBase64 = ref('');
const author = ref('');
const exporting = ref(false);
const exportImageUrl = ref(''); // Seems unused, but kept

const titleInputRef = ref(null);
const authorInputRef = ref(null);

// const bannerImages = [ // Static data, doesn't need ref/reactive
//   '/1.png',
//   '/2.png',
//   '/3.png',
//   '/4.png',
//   '/5.png',
//   '/6.png',
//   '/7.png',
// ];

// --- Lifecycle Hooks (Replaces mounted()) ---
onMounted(() => {
  document.title = 'AI 绘本创作工具';
});

// --- Methods (Replaces methods: { ... }) ---

async function generateStory() {
  loading.value = true;
  try {
    const themes = storyForm.themes.concat(storyForm.customThemes.split(/[，,]/).filter(item => item.trim() !== ''));
    const settings = storyForm.settings.concat(storyForm.customSettings.split(/[，,]/).filter(item => item.trim() !== ''));

    const requestData = {
      ...storyForm,
      themes: themes,
      settings: settings,
      // No need to send customThemes/customSettings if backend doesn't expect them separately
      // customThemes: undefined,
      // customSettings: undefined,
    };
    // Remove potentially undefined keys if backend is strict
    delete requestData.customThemes;
    delete requestData.customSettings;


    const response = await axios.post('https://art.hlqeai.cn/preview/api/generate_story', requestData);
    story.value = response.data.story;
    editableStory.value = response.data.story;
    step.value = 2;
  } catch (error) {
    console.error('生成故事时出错:', error);
    ElMessage.error('生成故事失败，请稍后重试。');
  } finally {
    loading.value = false;
  }
}

async function confirmStory() {
  loading2.value = true;
  try {
    const response = await axios.post('https://art.hlqeai.cn/preview/api/generate_character_info', {
      story: editableStory.value
    });

    // Clear previous data before adding new
    characterInfo.length = 0;
    newBasicTag.length = 0;
    newClothingTag.length = 0;
    loadingImage.length = 0; // Also clear loading states

    response.data.characters.forEach((character, index) => {
      characterInfo.push({
        ...character,
        name: character.name || '角色' + (index + 1),
        basic_features: character.basic_features || [],
        clothing_features: character.clothing_features || [],
        reference_image: character.reference_image || '', // Ensure reference_image exists
      });
      // Initialize corresponding input models and loading states
      newBasicTag.push('');
      newClothingTag.push('');
      loadingImage.push(false);
    });

    step.value = 3;
  } catch (error) {
    console.error("生成角色信息时出错", error);
    ElMessage.error("生成角色信息时出错，请稍后重试");
  } finally {
    loading2.value = false;
  }
}

function addCharacter() {
  if (characterInfo.length < 4) {
    characterInfo.push({ name: `角色${characterInfo.length + 1}`, basic_features: [], clothing_features: [], reference_image: '' });
    newBasicTag.push('');
    newClothingTag.push('');
    loadingImage.push(false); // Add loading state for the new character
  } else {
     ElMessage.warning('最多添加 4 个角色。');
  }
}

function removeCharacter(index) {
  if (characterInfo.length > 1) {
    characterInfo.splice(index, 1);
    newBasicTag.splice(index, 1);
    newClothingTag.splice(index, 1);
    loadingImage.splice(index, 1); // Remove corresponding loading state
  } else {
    ElMessage.warning('至少需要保留一个角色。');
  }
}

async function generateCharacterImage(index) {
  loadingImage[index] = true; // Start loading for this specific character

  try {
    const character = characterInfo[index];
    const requestData = {
      character_description: {
        name: character.name,
        basic_features: character.basic_features,
        clothing_features: character.clothing_features,
      },
      story_context: editableStory.value,
      style: visualOptionsForm.style,
    };

    const response = await axios.post('https://art.hlqeai.cn/preview/api/generate_character_image', requestData);
    // Ensure the character still exists (user might delete it while loading)
    if (characterInfo[index]) {
        characterInfo[index].reference_image = response.data.image_url;
    }

  } catch (error) {
    console.error(`生成角色 ${index + 1} 参考图失败`, error);
    ElMessage.error(`生成角色 ${index + 1} 参考图失败，请稍后重试`);
  } finally {
    // Check if the index is still valid before setting loading to false
    if (loadingImage.length > index) {
        loadingImage[index] = false; // End loading
    }
  }
}

function addTag(featuresArray, characterIndex, type) {
  let newTagInput = '';
  if (type === 'basic') {
    newTagInput = newBasicTag[characterIndex];
  } else if (type === 'clothing') {
    newTagInput = newClothingTag[characterIndex];
  }

  const tagValue = newTagInput.trim();
  if (tagValue) {
    if (!featuresArray.includes(tagValue)) { // Avoid duplicate tags
      featuresArray.push(tagValue);
      if (type === 'basic') newBasicTag[characterIndex] = '';
      if (type === 'clothing') newClothingTag[characterIndex] = '';
    } else {
       ElMessage.warning('该标签已存在');
    }
  }
}


function removeTag(featuresArray, tagIndex) {
  featuresArray.splice(tagIndex, 1);
}

async function confirmCharacters() {
  loading3.value = true;
  try {
    const response = await axios.post('https://art.hlqeai.cn/preview/api/generate_script', {
      story: editableStory.value,
      characters: characterInfo, // Send the potentially modified character info
    });

    // Clear existing script and pageImages before populating
    script.length = 0;
    pageImages.value = []; // Reset ref array

    response.data.script.forEach(item => {
        script.push(item); // Add items to the reactive array
        pageImages.value.push(''); // Initialize placeholder for image URL
    });

    step.value = 4;
    console.log("生成的分镜脚本", script);
  } catch (error) {
    console.error("生成分镜脚本时出错", error);
    ElMessage.error("生成分镜脚本时出错，请稍后重试");
  } finally {
    loading3.value = false;
  }
}

async function confirmScript() {
  loading4.value = true;
  try {
    const response = await axios.post('https://art.hlqeai.cn/preview/api/generate_text', {
      script: script, // Send the potentially modified script
    });

    storyForm.title = response.data.title;

    // Update script items with text from response
    response.data.script.forEach((updatedItem, index) => {
      if (script[index]) {
        script[index].text = updatedItem.text;
        // Optionally update other fields if the API modifies them
        // script[index].story_description = updatedItem.story_description;
        // script[index].image_description = updatedItem.image_description;
      }
    });

    currentPage.value = 0;
    step.value = 5;
  } catch (error) {
    console.error("生成配文和标题时出错", error);
    ElMessage.error("生成配文和标题时出错，请稍后重试");
  } finally {
    loading4.value = false;
  }
}

function prevPage() {
  if (currentPage.value > 0) {
    currentPage.value--;
  }
}

function nextPage() {
  if (currentPage.value < script.length - 1) {
    currentPage.value++;
  }
}

async function generateCurrentImage() {
  loading5.value = true;
  const pageIndex = currentPage.value; // Capture current page index

  // Basic validation: Ensure script item exists
  if (!script[pageIndex]) {
      console.error(`尝试为无效页面索引 ${pageIndex} 生成图像`);
      ElMessage.error("页面信息错误，无法生成图像");
      loading5.value = false;
      return;
  }

  try {
    // const currentPanel = script[pageIndex]; // Already accessible via script[pageIndex]

    const requestData = {
      story: editableStory.value,
      script: script, // Send the whole script for context
      page_index: pageIndex,
      images: pageImages.value, // Send existing images for context/consistency
      // No need to send image_description/text separately if included in script
      style: visualOptionsForm.style,
      characters: characterInfo,
      reader_age: storyForm.reader_age
    };

    const response = await axios.post('https://art.hlqeai.cn/preview/api/generate_image', requestData);

    // Update the specific image URL in the ref array
    // Check if currentPage hasn't changed drastically while waiting
    if (pageImages.value.length > pageIndex) {
        pageImages.value[pageIndex] = response.data.image_url;
    } else {
        console.warn(`页面索引 ${pageIndex} 在图像生成响应返回时已失效`);
    }

  } catch (error) {
    console.error(`生成页面 ${pageIndex + 1} 图像失败`, error);
    ElMessage.error(`生成页面 ${pageIndex + 1} 图像失败，请稍后重试`);
  } finally {
    loading5.value = false;
  }
}

function confirmAllImages() {
  const allImagesGenerated = pageImages.value.every(imageUrl => imageUrl && imageUrl !== '');
  if (!allImagesGenerated) {
    ElMessage.warning('请确保所有分镜的图像都已生成。');
    return;
  }

  // Add image URLs to the script reactive array before proceeding
  script.forEach((item, index) => {
    item.image_url = pageImages.value[index] || ''; // Assign URL or empty string
  });

  console.log("图像生成完毕，进入下一步", script);
  step.value = 6;
}

async function generateBook() {
  if (!storyForm.title || !storyForm.title.trim()) {
    ElMessage.error('请输入绘本标题！');
    titleInputRef.value?.focus(); // Focus the title input
    return; // Stop the function execution
  }
  if (!author.value || !author.value.trim()) {
    ElMessage.error('请输入作者姓名！');
    authorInputRef.value?.focus(); // Focus the author input
    return; // Stop the function execution
  }

  const allImagesGenerated = script.every(item => item.image_url && item.image_url !== '');
   if (!allImagesGenerated) {
    ElMessage.warning('数据不一致：部分图像URL缺失，请返回上一步检查。');
    // It might be better to re-run confirmAllImages logic here or disable the button
    // For now, just warn and return.
    return;
  }

  loading6.value = true;
  try {
    const response = await axios.post('https://art.hlqeai.cn/preview/api/create_book', {
      author: author.value,
      title: storyForm.title,
      script: script // script now contains image_url
    });
    firstPageUrl.value = response.data.first_page_url;
    qrcodeBase64.value = response.data.qrcode_base64;
    step.value = 7;
  } catch (error) {
    console.error('生成绘本时出错:', error);
    ElMessage.error('生成绘本失败，请稍后重试。');
  } finally {
    loading6.value = false;
  }
}

async function exportBook() {
  exporting.value = true;
  exportImageUrl.value = ''; // Clear previous if any

  if (!firstPageUrl.value) {
      ElMessage.error('无法导出：未找到绘本预览链接。');
      exporting.value = false;
      return;
  }

  try {
    const response = await axios.post('https://art.hlqeai.cn/preview/export', {
      preview_url: firstPageUrl.value,
    });

    const imageUrl = response.data.url;
    const filename = response.data.name || 'exported_book.png'; // Default filename

    if (!imageUrl) {
        throw new Error("API did not return an image URL for export.");
    }

    // Trigger download
    const link = document.createElement('a');
    link.href = imageUrl;
    link.setAttribute('download', filename);
    // Optional: For cross-origin images if needed and server allows CORS
    // link.setAttribute('target', '_blank');
    // link.setAttribute('rel', 'noopener noreferrer');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    ElMessage.success('绘本长图已开始下载！');

  } catch (error) {
    console.error('导出绘本时出错:', error);
    let errorMsg = '导出失败，请稍后重试。';
    if (error.response) {
      errorMsg = `导出失败: ${error.response.data?.error || error.response.statusText || '服务器错误'}`;
    } else if (error.request) {
      errorMsg = '导出失败: 服务器无响应';
    } else {
       errorMsg = `导出失败: ${error.message || '未知错误'}`;
    }
     ElMessage.error(errorMsg);
  } finally {
    exporting.value = false;
  }
}

function backtoLast() {
  if (step.value > 1) {
    step.value -= 1;
  }
}

function resetApp() {
  step.value = 1;
  loading.value = false;
  loading2.value = false;
  loading3.value = false;
  loading4.value = false;
  loading5.value = false;
  loading6.value = false;
  exporting.value = false;

  // Reset forms
  Object.assign(storyForm, {
    title: '',
    outline: '',
    character_names: '',
    genre: '',
    themes: [],
    customThemes: '',
    settings: [],
    customSettings: '',
    reader_age: '',
    reader_gender: '',
    language_style: '',
  });
  visualOptionsForm.style = 'cartoon';

  // Reset state variables
  story.value = '';
  editableStory.value = '';
  author.value = '';
  firstPageUrl.value = '';
  qrcodeBase64.value = '';
  imageUrl.value = '';
  exportImageUrl.value = '';
  currentPage.value = 0;

  // Clear reactive arrays
  characterInfo.length = 0;
  newBasicTag.length = 0;
  newClothingTag.length = 0;
  loadingImage.length = 0;
  script.length = 0;
  pageImages.value = []; // Reset ref array

  ElMessage.success('已重置，可以开始新的创作了！');
}

</script>


<style>
/* 全局样式 */
:root {
  --primary-color: #3498db;
  --secondary-color: #2ecc71;
  --warning-color: #f39c12;
  --danger-color: #e74c3c;
  --light-color: #ecf0f1;
  --dark-color: #34495e;
  --text-color: #2c3e50;
  --background-color: #f5f7fa;
  --card-background: #ffffff;
  --border-radius: 8px;
  --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  --transition: all 0.3s ease;
}

#app {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif, '微软雅黑';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
  font-size: 16px;
  line-height: 1.6;
  background-color: var(--background-color);
}

.app-header {
  --el-header-height: auto !important;
  padding: 0;
  position: relative;
  height: auto;
  overflow: hidden;
}

.top-banner {
  width: 100%;
  max-height: 960px;
  object-fit: contain;
  display: flex;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.custom-main {
  position: relative;
  margin-top: 50px;
  padding-bottom: 50px;
}

/* 步骤指示器样式 */
.step-indicator {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  position: relative;
  z-index: 10;
  padding: 0 20px;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
  max-width: 100px;
}

.step-item:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 15px;
  right: -50%;
  width: 100%;
  height: 2px;
  background-color: #ddd;
  z-index: -1;
}

.step-item:not(:last-child).active::after {
  background-color: var(--primary-color);
}

.step-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #ddd;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-weight: bold;
  transition: var(--transition);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.step-circle.active {
  background-color: var(--primary-color);
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);
}

.step-label {
  font-size: 12px;
  color: #666;
  text-align: center;
}

/* 主内容区样式 */
.main-content {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 30px;
  background-color: var(--card-background);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  position: relative;
  z-index: 5;
}

.step-container {
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.step-title {
  color: var(--primary-color);
  margin-bottom: 30px;
  text-align: center;
  font-weight: 500;
  position: relative;
  padding-bottom: 15px;
}

.step-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: var(--primary-color);
  border-radius: 3px;
}

/* 表单样式 */
.story-form, .story-confirm-form, .character-form, .image-gen-form {
  margin-top: 20px;
}

.el-form-item {
  margin-bottom: 25px;
}

.el-form-item__label {
  font-weight: 500;
  color: var(--dark-color);
}

.full-width {
  width: 100%;
}

.el-textarea__inner {
  border-radius: 8px;
  padding: 12px;
  font-size: 15px;
  transition: var(--transition);
  border: 1px solid #dcdfe6;
}

.el-textarea__inner:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.el-input__inner {
  border-radius: 8px;
  height: 42px;
  transition: var(--transition);
}

.el-input__inner:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.checkbox-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.el-checkbox {
  margin-right: 0;
  margin-bottom: 8px;
}

/* 按钮样式 */
.center-buttons {
  text-align: center;
  margin-top: 30px;
}

.action-button {
  min-width: 120px;
  height: 42px;
  border-radius: 21px;
  font-size: 15px;
  font-weight: 500;
  transition: var(--transition);
  margin: 0 10px;
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

.prev-button {
  background-color: #f5f7fa;
  border-color: #dcdfe6;
  color: #606266;
}

.prev-button:hover {
  background-color: #e9ecef;
  color: #303133;
}

.style-selection {
  margin-top: 30px;
}

.style-radio-content {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

/* 角色区域样式 */
.character-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-bottom: 30px;
}

.character-container {
  border: 1px solid #e0e0e0;
  border-radius: var(--border-radius);
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: var(--transition);
}

.character-container:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.character-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.character-title {
  margin: 0;
  color: var(--primary-color);
  font-size: 18px;
}

.delete-btn {
  border-radius: 20px;
  padding: 7px 15px;
}

.character-content {
  display: flex;
  gap: 30px;
}

.character-info {
  flex: 1;
}

.character-image {
  width: 220px;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.feature-tag {
  border-radius: 16px;
  padding: 0 12px;
  height: 32px;
  line-height: 30px;
  background-color: rgba(52, 152, 219, 0.1);
  transition: var(--transition);
}

.feature-tag:hover {
  transform: translateY(-2px);
}

.tag-input {
  margin-top: 10px;
}

.image-preview {
  width: 180px;
  height: 320px;
  border-radius: var(--border-radius);
  border: 1px dashed #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #f5f7fa;
}

.no-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #909399;
}

.no-image i {
  font-size: 40px;
  margin-bottom: 10px;
}

.image-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.add-character-wrapper {
  text-align: center;
  margin-bottom: 20px;
}

.add-character-btn {
  border-radius: 20px;
}

.generate-image-btn {
  margin-top: 15px;
}

/* 分镜脚本样式 */
.script-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  grid-gap: 25px;
}

.script-item {
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: var(--border-radius);
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: var(--transition);
}

.script-item:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.script-header {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.script-number {
  font-size: 18px;
  font-weight: 500;
  color: var(--primary-color);
}

.script-scene {
  background-color: #f0f7ff;
  padding: 4px 12px;
  border-radius: 15px;
  color: var(--primary-color);
  font-size: 14px;
}

.script-textarea {
  border-radius: 8px;
}

/* 图像生成页面样式 */
.page-container {
  border: 1px solid #e0e0e0;
  border-radius: var(--border-radius);
  padding: 0;
  background-color: #fff;
  box-shadow: var(--box-shadow);
  overflow: hidden;
}

.page-header {
  background-color: #f5f7fa;
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.page-navigation {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.page-indicator {
  font-size: 16px;
  font-weight: 500;
  color: var(--dark-color);
  min-width: 70px;
  text-align: center;
}

.nav-btn {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-content {
  display: flex;
  padding: 25px;
}

.page-left {
  flex: 1;
  margin-right: 30px;
}

.scene-title {
  margin-top: 0;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.scene-number {
  font-size: 18px;
  font-weight: 600;
  color: var(--primary-color);
}

.scene-name {
  background-color: #f0f7ff;
  padding: 4px 12px;
  border-radius: 15px;
  color: var(--primary-color);
  font-size: 14px;
}

.description-textarea, .text-textarea {
  font-size: 15px;
}

.generate-btn {
  margin-top: 20px;
}

.page-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container {
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  border: 1px dashed #dcdfe6;
}

.generated-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.no-image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  text-align: center;
  padding: 30px;
}

.no-image-placeholder i {
  font-size: 60px;
  margin-bottom: 15px;
  opacity: 0.5;
}

.action-buttons {
  padding: 20px;
  border-top: 1px solid #eee;
}

/* 绘本内容确认样式 */
.book-info-form {
  max-width: 600px;
  margin: 0 auto 30px;
}

.four-grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  gap: 25px;
  margin-bottom: 30px;
}

.grid-item {
  position: relative;
}

.grid-item-inner {
  border: 1px solid #e0e0e0;
  border-radius: var(--border-radius);
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: var(--transition);
}

.grid-item-inner:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(-3px);
}

.grid-image-container {
  position: relative;
  /*padding-bottom: 75%; !* 4:3 Aspect Ratio *!*/
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background-color: #f5f7fa;
}

.grid-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.page-number {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: var(--primary-color);
  color: white;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.grid-text-form {
  padding: 15px;
}

.grid-textarea {
  border-radius: 8px;
}

/* 完成页面样式 */
.final-step {
  text-align: center;
}

.success-title {
  color: var(--secondary-color);
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.completion-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 30px;
  background-color: #f8f9fa;
  border-radius: var(--border-radius);
}

.qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
}

.qrcode-image {
  width: 200px;
  height: 200px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  padding: 10px;
  background-color: white;
  margin-bottom: 15px;
  transition: var(--transition);
}

.qrcode-image:hover {
  transform: scale(1.05);
}

.qrcode-hint {
  color: #666;
  margin: 5px 0 20px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}

.book-link {
  text-decoration: none;
}

.start-reading-button, .export-button {
  min-width: 150px;
  height: 44px;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 500;
}

.restart-container {
  margin-top: 20px;
}

.new-book-button {
  min-width: 180px;
  height: 44px;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 500;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .main-content {
    width: 95%;
    padding: 30px 20px;
  }

  .script-grid, .four-grid-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 992px) {
  .character-content {
    flex-direction: column;
  }

  .character-image {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  .image-preview {
    width: 180px;
    height: 180px;
  }

  .page-content {
    flex-direction: column;
  }

  .page-left {
    margin-right: 0;
    margin-bottom: 30px;
  }

  .image-container {
    height: 350px;
  }
}

@media (max-width: 768px) {
  .step-indicator {
    overflow-x: auto;
    padding-bottom: 10px;
  }

  .step-item {
    min-width: 80px;
  }

  .step-label {
    font-size: 11px;
  }

  .action-buttons {
    flex-direction: column;
    gap: 15px;
  }

  .start-reading-button, .export-button {
    width: 100%;
  }

  .scene-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .page-header {
    padding: 10px;
  }

  .page-navigation {
    gap: 10px;
  }
}

@media (max-width: 576px) {
  .main-content {
    width: 100%;
    border-radius: 0;
    padding: 20px 15px;
  }

  .step-title {
    font-size: 20px;
  }

  .el-form-item__label {
    float: none;
    display: block;
    text-align: left;
    padding: 0 0 10px;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }

  .image-container {
    height: 280px;
  }

  .character-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .delete-btn {
    align-self: flex-end;
  }
}
</style>


